import {Chip, IconButton, Tooltip, Typography} from "@material-tailwind/react";
import React, {useContext, useState} from "react";
import {ServiceContext} from "../../context/service";
import persianNumberFormat from "../../helper/PersianNumberFormat";
import {TableHead} from "../system/thead";
import {PencilIcon} from "@heroicons/react/24/solid";
import TableTdContent from "../system/tableTdContent";


const TABLE_HEAD = ["مرحله", "عنوان", "توضیحات", "مهلت", "وضعیت انجام", "به‌روزرسانی", "عملیات"];

export function AgentServiceStepsGrid() {

  const {
    setModalOpen,
    setStep,
    serviceSteps,
    setServiceStep
  } = useContext(ServiceContext);

  const [selectedHead, setSelectedHead] = useState("#")

  const headMap = {
    "مرحله": "step",
    "عنوان": "title",
    "توضیحات": "description",
    "مهلت": "days",
    "وضعیت انجام": "is_done",
    "به‌روزرسانی": "updated_at",
    "عملیات": "",
  }

  const headSortable = {
    "مرحله": false,
    "عنوان": false,
    "توضیحات": false,
    "مهلت": false,
    "وضعیت انجام": false,
    "به‌روزرسانی": false,
    "عملیات": false,
  }

  return (<div>
    <table className="mt-4 text-left w-full">
      <TableHead
        tableHead={TABLE_HEAD}
        headSortable={headSortable}
        headMap={headMap}
        selectedHead={selectedHead}
        setSelectedHead={setSelectedHead}
      />
      {serviceSteps && serviceSteps.length > 0 &&
        <tbody className="textCenter">
        {[...serviceSteps].sort((a, b) => a.step - b.step).map(({
                                                                  id,
                                                                  title,
                                                                  description,
                                                                  step,
                                                                  days,
                                                                  is_done,
                                                                  updated_at,
                                                                }, index) => {

          const isLast = index === serviceSteps.length - 1;
          const classes = isLast ? "p-4" : "p-4 border-b border-blue-gray-50";

          return (<tr key={id} className={days === 0 ? "bg-red-200" : ""}>

            <td className={classes}>
              <div className="flex justify-center px-4">
                <Typography color="blue-gray" className="textRight">
                  {persianNumberFormat(step, true)}
                </Typography>
              </div>
            </td>

            <td className={`${classes}`}>
              <div className="flex justify-center px-4">
                <Typography color="blue-gray" className="textRight">
                  {title}
                </Typography>
              </div>
            </td>

            <td className={`${classes}`}>
              <TableTdContent content={`${description}`}/>
            </td>

            <td className={classes}>
              <div className="flex justify-center px-4">
                <Typography color="blue-gray" className="textRight">
                  {persianNumberFormat(days, true)}
                </Typography>
              </div>
            </td>

            <td className={classes}>
              <div className="flex justify-center px-4">
                <Chip
                  variant="ghost"
                  color={is_done ? "green" : "red"}
                  size="sm"
                  value={is_done ? "بله" : "خیر"}
                />
              </div>
            </td>

            <td className={classes}>
              <div className="flex flex-col justify-center px-4">
                <Typography color="blue-gray">
                  {persianNumberFormat(updated_at.split(" ")[0])}
                </Typography>
                <Typography color="blue-gray">
                  {persianNumberFormat(updated_at.split(" ")[1])}
                </Typography>

              </div>
            </td>

            <td className={classes}>
              <Tooltip content="ویرایش">
                <IconButton variant="text" className="text-align=right" onClick={() => {
                  setServiceStep(serviceSteps[index]);
                  setModalOpen(true);
                  setStep("step")
                }}>
                  <PencilIcon className="h-4 w-4"/>
                </IconButton>
              </Tooltip>
            </td>
          </tr>);
        },)}
        </tbody>
      }
    </table>
  </div>);
}